
export class LineInMain {
    comp: number
    description: string
    date: string
    key: string

    constructor(jsonObject: any) {
        this.comp = jsonObject.comp
        this.description = jsonObject.description
        this.date = jsonObject.date
        this.key = jsonObject.comp.toString()
    }

    static instantiateFromArr(jsonObjects: any[]) {
        return jsonObjects.map(jsonObject => new LineInMain(jsonObject))
    }

}